import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../../core/api/api.service';
import { DYNAMIC_SERVICES_ENDPOINTS } from '../../../../core/api/endpoints/dynamic-services.endpoints';
import { BUTTON_LOADING_ID } from 'src/app/shared/global/http-context-tokens';

@Injectable({
  providedIn: 'root',
})
export class DynamicServices {
  private api = inject(ApiService);

  getServices(params): Observable<any> {
    return this.api.get(DYNAMIC_SERVICES_ENDPOINTS.V1.ADMIN_DYNAMIC_SERVICES, {
      params: params,
    });
  }

  getAdditions(params): Observable<any> {
    return this.api.get(DYNAMIC_SERVICES_ENDPOINTS.V1.ADMIN_DYNAMIC_SERVICE_ADDITIONS, {
      params: params,
    });
  }

  addNewService(service): Observable<any> {
    return this.api.post(DYNAMIC_SERVICES_ENDPOINTS.V1.ADMIN_DYNAMIC_SERVICES, service);
  }

  getServiceById(id): Observable<any> {
    return this.api.get<any>(DYNAMIC_SERVICES_ENDPOINTS.V1.ADMIN_DYNAMIC_SERVICE_DETAIL(id));
  }

  updateService(id, service, buttonId?): Observable<any> {
    return this.api.put<any>(
      DYNAMIC_SERVICES_ENDPOINTS.V1.ADMIN_DYNAMIC_SERVICE_DETAIL(id),
      service,
      { context: new HttpContext().set(BUTTON_LOADING_ID, buttonId) }
    );
  }

  deleteService(id): Observable<any> {
    return this.api.delete(DYNAMIC_SERVICES_ENDPOINTS.V1.ADMIN_DYNAMIC_SERVICE_DETAIL(id));
  }

  getDynamicServicesChoices() {
    return this.api.get(DYNAMIC_SERVICES_ENDPOINTS.V1.ADMIN_SHOW_TERMS_CHOICES);
  }

  getStatusCustomDisplay(payload) {
    return this.api.get(DYNAMIC_SERVICES_ENDPOINTS.V1.ADMIN_COMPLETION_STATUSES,{params: payload});
  }

  getStatusCustomById(id) {
    return this.api.get(DYNAMIC_SERVICES_ENDPOINTS.V1.ADMIN_COMPLETION_STATUS_DETAIL(id));
  }

  getBuildingData(): Observable<any> {
    return this.api.get(DYNAMIC_SERVICES_ENDPOINTS.V1.ADMIN_BUILDING_DATA_TO_SHOW);
  }

  redistrebuteRatios(id): Observable<any> {
    return this.api.put(DYNAMIC_SERVICES_ENDPOINTS.V1.UPDATE_SERVICE_ALL_RATIOS(id), {});
  }

  getDynamicAdditionChoices() {
    return this.api.get(DYNAMIC_SERVICES_ENDPOINTS.V1.ADDITION_STATUS_CHOICES);
  }

  getDynamicAdditionFieldChoices() {
    return this.api.get(DYNAMIC_SERVICES_ENDPOINTS.V1.ADDITION_FIELD_TYPES);
  }

  addDynamicAddition(Addition): Observable<any> {
    return this.api.post<any>(DYNAMIC_SERVICES_ENDPOINTS.V1.ADMIN_DYNAMIC_SERVICE_ADDITIONS, Addition);
  }

  updateDynamicAddition(id, Addition): Observable<any> {
    return this.api.put<any>(DYNAMIC_SERVICES_ENDPOINTS.V1.ADMIN_DYNAMIC_SERVICE_ADDITION_DETAIL(id), Addition);
  }

  getDynamicAdditionById(id): Observable<any> {
    return this.api.get(DYNAMIC_SERVICES_ENDPOINTS.V1.ADMIN_DYNAMIC_SERVICE_ADDITION_DETAIL(id));
  }

  deleteAddition(id): Observable<any> {
    return this.api.delete(DYNAMIC_SERVICES_ENDPOINTS.V1.ADMIN_DYNAMIC_SERVICE_ADDITION_DETAIL(id));
  }

  getNotesDisplayChoices() {
    return this.api.get(DYNAMIC_SERVICES_ENDPOINTS.V1.NOTES_DISPLAY_CHOICES);
  }

  checkServiceCoverage(params): Observable<any> {
    return this.api.get(DYNAMIC_SERVICES_ENDPOINTS.V1.SERVICE_COVERAGE_CHECK, { params: params });
  }
}
